// Cravy Home - Socials v2: each of the 5 tilted cards can show a photo OR a video, with a
// card shape of original / 4:5 post / 9:16 story. Registered as data-slice="socials2".
// The original `socials` component in cravy-sections2.js is untouched: remove the <script> tag
// for this file from sections/cr-home-socials.liquid and set data-slice back to "socials" to restore.
// Uses globals from earlier scripts: React, H, P, useIsMobile.
(function () {
  window.CravyHome = window.CravyHome || {};
  function pickSrc(list) {
    var mp = (list || []).filter(function (s) { return s && s.f === 'mp4' && s.url; })
      .sort(function (a, b) { return a.h - b.h; });
    if (!mp.length) return '';
    for (var i = 0; i < mp.length; i++) if (mp[i].h >= 720) return mp[i].url;
    return mp[mp.length - 1].url;
  }

  function VideoCard(props) {
    var h = React.createElement;
    var ref = React.useRef(null);
    var ms = React.useState(true);
    var muted = ms[0], setMuted = ms[1];
    React.useEffect(function () {
      var v = ref.current;
      if (!v) return;
      v.muted = muted;
    }, [muted]);
    React.useEffect(function () {
      var v = ref.current;
      if (!v) return;
      v.muted = true;
      v.defaultMuted = true;
      var go = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if (!('IntersectionObserver' in window)) { go(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) go(); else v.pause(); });
      }, { threshold: 0.25 });
      io.observe(v);
      return function () { io.disconnect(); };
    }, [props.src]);
    return h(React.Fragment, null,
      h('video', {
        ref: ref,
        src: props.src,
        poster: props.poster || undefined,
        loop: true,
        playsInline: true,
        autoPlay: true,
        preload: 'metadata',
        style: { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', display: 'block' }
      }),
      h('button', {
        type: 'button',
        'aria-label': muted ? 'Unmute video' : 'Mute video',
        onClick: function (e) { e.preventDefault(); e.stopPropagation(); setMuted(function (m) { return !m; }); },
        style: {
          position: 'absolute', right: 12, bottom: 12, width: 38, height: 38, borderRadius: '50%',
          background: 'rgba(0,0,0,0.45)', border: 'none', padding: 0, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }
      },
      h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: '#fff' },
        muted
          ? h('path', { d: 'M3 9v6h4l5 4V5L7 9H3zm13.6 3l2.4-2.4-1.4-1.4-2.4 2.4-2.4-2.4-1.4 1.4 2.4 2.4-2.4 2.4 1.4 1.4 2.4-2.4 2.4 2.4 1.4-1.4z' })
          : h('path', { d: 'M3 9v6h4l5 4V5L7 9H3zm13.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4z' }))));
  }

function Socials2({
  cfg
}) {
  const c = cfg || {};
  const m = useIsMobile();
  const nets = [{
    n: 'Instagram',
    href: P(c.instagram, '')
  }, {
    n: 'Facebook',
    href: P(c.facebook, '')
  }, {
    n: 'TikTok',
    href: P(c.tiktok, '')
  }];
  const hs = [380, 440, 320, 420, 360];
  const cards = hs.map((hh, k) => {
    const n = k + 1;
    const vsrc = pickSrc(c['vid' + n]);
    const img = P(c['img' + n], '');
    return {
      id: 'social-' + n,
      h: hh,
      img: img,
      ratio: P(c['ratio' + n], 'auto'),
      video: P(c['media' + n], 'photo') === 'video' && vsrc ? vsrc : '',
      poster: P(c['poster' + n], '') || img
    };
  });
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Socials",
    style: {
      background: P(c.bg, 'var(--cravy-orange)'),
      padding: 'clamp(70px,10vh,130px) 0 clamp(60px,8vh,100px)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      padding: '0 clamp(20px,5vw,80px)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 'clamp(13px,1vw,18px)',
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: '#fff',
      marginBottom: 52
    },
    dangerouslySetInnerHTML: H(P(c.eyebrow, 'Join the craving'))
  }), /*#__PURE__*/React.createElement("h2", {
    style: {
      color: '#fff'
    },
    dangerouslySetInnerHTML: H(P(c.heading, 'Follow @cravyfries for more'))
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 16,
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginTop: 'clamp(30px,5vh,54px)',
      padding: '0 20px'
    }
  }, nets.map(net => /*#__PURE__*/React.createElement("a", {
    key: net.n,
    href: net.href || '#',
    target: "_blank",
    rel: "noopener",
    className: "socialbtn",
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 40,
      minWidth: 250,
      textDecoration: 'none',
      background: 'var(--cravy-maroon)',
      color: '#fff',
      borderRadius: 14,
      padding: '16px 16px 16px 24px',
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 16
    }
  }, net.n, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 34,
      height: 34,
      borderRadius: 999,
      background: '#fff',
      color: 'var(--cravy-maroon)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 18
    }
  }, "→")))), /*#__PURE__*/React.createElement("div", {
    id: "cravy-instafeed",
    style: {
      overflow: 'hidden',
      marginTop: 'clamp(46px,7vh,90px)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: m ? 16 : 'clamp(14px,1.6vw,26px)',
      alignItems: 'center',
      justifyContent: m ? 'flex-start' : 'center',
      width: m ? 'max-content' : 'auto',
      padding: '0 10px',
      animation: m ? 'marq 28s linear infinite' : 'none'
    }
  }, (m ? cards.concat(cards) : cards).map((cd, i) => /*#__PURE__*/React.createElement("div", {
    key: cd.id + '-' + i,
    className: "socard",
    style: {
      position: 'relative',
      flex: m ? '0 0 74vw' : '0 0 clamp(200px,18vw,300px)',
      height: cd.ratio !== 'auto' ? undefined : (m ? Math.round(cd.h * 1.15) : cd.h),
      aspectRatio: cd.ratio !== 'auto' ? cd.ratio : undefined,
      borderRadius: 16,
      overflow: 'hidden',
      transform: `rotate(calc(${i % 2 ? 1 : -1}deg*var(--k,1)))`
    }
  }, cd.video ? React.createElement(VideoCard, {
    src: cd.video,
    poster: cd.poster
  }) : /*#__PURE__*/React.createElement("image-slot", {
    id: cd.id,
    shape: "rounded",
    radius: "16",
    fit: "cover",
    src: cd.img,
    placeholder: "Drop a social post image or video still"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 14,
      left: 14,
      background: '#000',
      color: '#fff',
      fontFamily: 'var(--font-body)',
      fontWeight: 600,
      fontSize: 12.5,
      padding: '8px 14px',
      borderRadius: 999,
      pointerEvents: 'none'
    }
  }, "Instagram"))))));
}
  window.CravyHome.socials2 = Socials2;
})();
